import { render, staticRenderFns } from "./Acerca.vue?vue&type=template&id=9b5960fe&scoped=true&lang=pug&"
var script = {}
import style0 from "./Acerca.vue?vue&type=style&index=0&id=9b5960fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5960fe",
  null
  
)

export default component.exports